import {createStore, applyMiddleware, compose} from 'redux'
import reduxThunk from 'redux-thunk'
import reducers from './reducer'

const storeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, {},storeEnhancers(applyMiddleware(reduxThunk)));

export default store;